// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import { hiraganas } from "../consts/hiraganaList";
import { katakana } from "../consts/katakana";

const romajiBySymbol = new Map();
for (const { symbol, romaji } of [...hiraganas, ...katakana]) {
    if (!romaji || romaji.startsWith("small-") || romaji === "dot" || romaji === "space") continue;
    if (!romajiBySymbol.has(symbol)) romajiBySymbol.set(symbol, romaji);
}

const smallTsuChars = new Set(["っ", "ッ"]);
const longVowelChars = new Set(["ー"]);
const consonantPattern = /^[bcdfghjklmnpqrstvwxyz]$/;

// Finds the romaji for the next actual kana mora, skipping over "." and "-"
// notation characters (KANJIDIC's okurigana/suffix markers aren't part of the
// pronunciation, so a small tsu right before one still doubles the consonant
// that follows it, e.g. "やっ.つ" -> "yat.tsu").
function peekRomaji(chars, index) {
    let i = index;
    while (i < chars.length && (chars[i] === "." || chars[i] === "-")) i += 1;
    if (i >= chars.length) return null;
    const two = chars.slice(i, i + 2).join("");
    if (romajiBySymbol.has(two)) return romajiBySymbol.get(two);
    return romajiBySymbol.get(chars[i]) || null;
}

// Converts a kana reading (as found in KANJIDIC, e.g. "い.く" or "-ゆき") to
// romaji, keeping the "." okurigana boundary and leading "-" suffix marker
// from the source notation as literal separators.
export function kanaToRomaji(text) {
    const chars = [...String(text || "")];
    let result = "";
    let i = 0;

    while (i < chars.length) {
        const char = chars[i];

        if (char === "." || char === "-") {
            result += char;
            i += 1;
            continue;
        }

        if (smallTsuChars.has(char)) {
            const next = peekRomaji(chars, i + 1);
            if (next) {
                result += next.startsWith("ch") ? "t" : consonantPattern.test(next[0]) ? next[0] : "";
            }
            i += 1;
            continue;
        }

        if (longVowelChars.has(char)) {
            result += result.slice(-1);
            i += 1;
            continue;
        }

        const two = chars.slice(i, i + 2).join("");
        if (romajiBySymbol.has(two)) {
            result += romajiBySymbol.get(two);
            i += 2;
            continue;
        }

        if (romajiBySymbol.has(char)) {
            result += romajiBySymbol.get(char);
            i += 1;
            continue;
        }

        result += char;
        i += 1;
    }

    return result;
}
